import React from 'react';
import {observer} from 'mobx-react';
import {Panel, CopyableField, ActionLink} from 'components';
import {withState, t} from 'shared/core';
import {FormattedMessage} from 'react-intl';
import useModal from 'shared/hooks/useModal';
import CalendarInstructionsModal from './CalendarInstructionsModal';
import {CalendarsContainerState} from '../state';

const CalendarLinkRow = observer(({name, link}) => {
  return (
    <div>
      <div className='h4 jumbo mb1'>{name}</div>
      <CopyableField fieldValue={link}/>
    </div>
  );
});

const CalendarLinks = observer(({uiState}) => {
  const {employeeCalendars, calendarSubscriptions} = uiState;

  return (
    <div className='space-y-2'>
      {employeeCalendars.map(employeeCalendar =>
        <CalendarLinkRow
          key={employeeCalendar.externalId}
          name={t(`models.calendar_type.${employeeCalendar.calendar.calendarType}.name`)}
          link={employeeCalendar.links.calendarFeed}
        />
      )}
      {calendarSubscriptions.map(calendarSubscription =>
        <CalendarLinkRow
          key={calendarSubscription.externalId}
          name={calendarSubscription.name}
          link={calendarSubscription.links.calendarFeed}
        />
      )}
    </div>
  );
});

const CalendarsContainer = observer(({uiState}) => {
  const {hasCalendars} = uiState;
  const calendarInstructionsModalOpen = useModal(uiState, 'CalendarInstructionsModal');

  if (!hasCalendars) return null;

  return (
    <Panel>
      <Panel.Header
        title={t('employees.profile.calendars.Company Calendars')}
        description={<React.Fragment>
          <FormattedMessage id='employees.profile.calendars.Use the following links to subscribe to calendar feeds for your company.'/>&nbsp;
          <ActionLink onClick={() => uiState.openCalendarInstructionsModal()}>
            <FormattedMessage id='employees.profile.calendars.Learn more'/>
          </ActionLink>
        </React.Fragment>}
      />
      <CalendarLinks uiState={uiState}/>
      <CalendarInstructionsModal modalOpen={calendarInstructionsModalOpen} uiState={uiState}/>
    </Panel>
  );
});

export default withState(CalendarsContainer, CalendarsContainerState);
